import EBResumeCard from "./EBResumeCard";

export default EBResumeCard;
